import {Component, Input} from '@angular/core';

@Component({
    selector: 'ftl-form-group',
    template: `
        <div class="form-group">
            <label [ngClass]="getLabelClass()">
                {{ label }}
            </label>

            <div [ngClass]="getContentClass()">
                <ng-content></ng-content>
            </div>
        </div>
    `
})
export class FormGroupComponent {

    @Input('id') id: string;
    @Input('label') label: string;

    @Input('is-cte') cte: boolean = false;
    @Input('is-large') large: boolean = false;

    getLabelClass(): any {
        return {
            'control-label': true,
            'col-xs-12': true,
            'col-sm-6': true,
            'col-lg-3': this.large
        }
    }

    getContentClass(): any {
        return {
            'control-container': !this.cte,
            'col-xs-12': true,
            'col-sm-6': true,
            'col-lg-9': this.large
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/elements/form/form-group.component.ts